import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { useCurrentPage } from '»utils/customHooks';

import BancoValorBgLPage from '../../../assets/img/BVALOR_bg-lpage-sm.webp';
import { GradientContainer, TextContainer } from '../AppCard.styles';
import {
  BackgroundMobileImageStyled,
  BoxBackgroundImageStyled,
  CardContainer,
  LandingPageText,
} from './AppCardBancoValor.styles';

export const AppCardBancoValor = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const { isLoginPage } = useCurrentPage(location.pathname);

  if (isDesktop)
    return (
      <BoxBackgroundImageStyled isLoginPage={isLoginPage}>
        <GradientContainer>
          <TextContainer isFormPage={isLoginPage}>
            <LandingPageText isLoginPage={isLoginPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_BVALOR" />
            </LandingPageText>
          </TextContainer>
        </GradientContainer>
      </BoxBackgroundImageStyled>
    );

  return (
    <CardContainer isLoginPage={isLoginPage}>
      <LandingPageText isLoginPage={isLoginPage}>
        <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_BVALOR" />
      </LandingPageText>
      <BackgroundMobileImageStyled
        alt="background-mobile-image"
        component="img"
        src={BancoValorBgLPage}
        isLoginPage={isLoginPage}
      />
    </CardContainer>
  );
};
